export const ROUTES = {
  home: "/",
  devicePanel: "/device-panel",
  settings: "/settings",
  device_settings: "/device-settings",
  schedule: "/schedule",
  gallery: "/gallery",
};
